<template>

    <div class="login-template">
        <div class="left-side">
            <div class="top">
                <a href="/" class="logo">
                    <logo></logo>
                </a>
            </div>
            <div class="login-content">
                <div class="content">
                    <h1>{{ $t('tenant.contract-register.headline') }}</h1>
                    <form>
                        <div class="material-input">
                            <input id="email" type="email" v-model="form.email"
                                   class="form-control" name="email" required autofocus>
                            <p class="label"><label for="email">
                                {{ $t('login.form.email') }}
                            </label></p>
                        </div>
                        <div class="material-input">
                            <input id="password" v-model="form.password"
                                   type="password" class="form-control" name="password" required>
                            <p class="label"><label for="password">{{ $t('login.form.password') }}</label></p>
                        </div>
                        <div class="material-input">
                            <input id="password-confirm" type="password" class="form-control"
                                   name="password_confirmation" v-model="form.password_confirmation" required>
                            <p class="label"><label for="password">{{ $t('login.form.password') }}</label></p>
                        </div>
                        <div class="button-container">
                            <button type="submit" :disabled="!validateInput" class="purple" @click.prevent="register">
                                {{ $t('button.signup') }}
                            </button>
                            <div>
                                <a href="">{{ $t('tenant.register.what-label') }}</a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="bottom">
                <copyright></copyright>
                <span class="seperator">|</span>
                <a target="_blank" href="https://www.rently.dk/terms/">{{ $t('login.terms-conditions') }}</a>
            </div>
        </div>
        <div class="right-side contract-register">
            <div class="content">
                <div class="text">
                    <h2>{{ $t('tenant.contract-register.teaser.headline') }}</h2>
                    <ul>
                        <li>
                            <simple-svg
                                :filepath="'images/SVG/CheckmarkCircle.svg'"
                                :width="'20px'"
                                :height="'20px'"
                            />
                            <span>{{ $t('tenant.contract-register.teaser.reason-one') }}</span>
                        </li>
                        <li>
                            <simple-svg
                                :filepath="'images/SVG/CheckmarkCircle.svg'"
                                :width="'20px'"
                                :height="'20px'"
                            />
                            <span>{{ $t('tenant.contract-register.teaser.reason-two') }}</span>
                        </li>
                        <li>
                            <simple-svg
                                :filepath="'images/SVG/CheckmarkCircle.svg'"
                                :width="'20px'"
                                :height="'20px'"
                            />
                            <span>{{ $t('tenant.contract-register.teaser.reason-three') }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Logo from '../../components/Logo';
import Copyright from '../../components/Copyright';
import Form from 'vform';
import {mapGetters} from 'vuex';
import {store} from "../../store";

export default {
    async beforeRouteEnter(to, from, next) {
        if (store.getters.getToken) {
            next('/');
        }
        if (JSON.stringify(to.params).length > 2) {
            await store.dispatch('fetchEmailByHash', to.params.hash);
            next();
        } else {
            await store.commit('setEmail', '');
            next();
        }
    },
    data: () => ({
        form: new Form({
            email: '',
            password: '',
            password_confirmation: '',
            user_role: 1,
        }),
    }),
    created() {
        this.form.email = this.getEmail;
    },
    computed: {
        validateInput() {
            return this.validEmail(this.form.email) && this.form.password && (this.form.password === this.form.password_confirmation);
        },
        ...mapGetters([
            'getEmail'
        ])
    },
    components: {
        Logo,
        Copyright
    },
    methods: {
        validEmail(email) {
            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        async register() {
            const {data} = await this.form.post(this.$root.apiUrl + 'api/register');
            this.$store.commit('setToken', data.token);
            this.$router.push('/');
        }
    }
}
</script>

<style scoped>

</style>
